var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "message-viewer" },
    [
      _c("Message", {
        key: "TEST",
        attrs: {
          id:
            "sc-message_" +
            (_vm.$_.get(_vm.message, "id") ||
              _vm.$_.get(_vm.message, "raw.uniqMessageId")),
          colors: _vm.colors,
          "is-chat-window": false,
          "is-colored": false,
          message: _vm.message,
          "random-bg-color-with-name": false,
          showAvatar: false,
          user: _vm.profile(_vm.message),
          "disable-translation": true,
          "is-whatsapp": false,
          "channel-id": null,
          "reply-mode": true,
          "override-style": { "max-width": "unset !important" },
        },
        on: {
          remove: function ($event) {
            return _vm.$emit("remove", _vm.message)
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "user-avatar",
              fn: function (scopedProps) {
                return [
                  _vm._t("user-avatar", null, {
                    message: scopedProps.message,
                    user: scopedProps.user,
                  }),
                ]
              },
            },
            {
              key: "text-message-body",
              fn: function (scopedProps) {
                return [
                  _vm._t("text-message-body", null, {
                    me: scopedProps.me,
                    message: scopedProps.message,
                    messageColors: scopedProps.messageColors,
                    messageText: scopedProps.messageText,
                  }),
                ]
              },
            },
            {
              key: "text-message-toolbox",
              fn: function (scopedProps) {
                return [
                  _vm._t("text-message-toolbox", null, {
                    me: scopedProps.me,
                    message: scopedProps.message,
                  }),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _c("IconButton", { attrs: { "on-click": _vm.remove } }, [
        _c("span", { staticClass: "material-icons" }, [_vm._v(" close ")]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }